import {useTranslation} from "react-i18next";
import {useEffect, useRef, useState} from "react";
// -
import NavBreadcrum from "components/NavBreadcrum";
import navs from "./navs";
import {SwalAlertClass} from "core/swalClass";
import axiApi from "ApiCaller";
import ContainersListFilters from "./performance/ContainersListFilters";
import ContainersListTable from "./performance/ContainersListTable";
import LoaderSpinner from "context/LoaderSpinner";
import FilterModel from "components/FilterModel";
import TopBarPagination from "components/paginator/TopBarPagination-v2";
import {PagerModel} from "components/paginator/PaginationModel";
import OrderingModel from "components/ordering/OrderingModel";

const SelectedModel = {
    question: false,
    all: false,
    textQuestion: "",
    textAll: "",
};

const ReportPerformance = () => {
    const {t: _Tr} = useTranslation("routes");
    const {t: _Tt} = useTranslation("tables");
    const bread = [
        {name: _Tr("labels.reports"), url: "/reports/", current: false},
        {name: _Tr("labels.performance"), current: true},
    ];
    const Alert = new SwalAlertClass({confirmButtonText: "Aceptar"});
    const title = _Tr("labels.performance");

    const selected = useRef([]);
    const itemsRef = useRef([]);
    const filters = useRef(new FilterModel());
    const pagerRef = useRef(new PagerModel());
    const orderingRef = useRef(new OrderingModel());

    const [itemsShown, setItemsShown] = useState([]);
    const [days, setDays] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [checkedAll, setCheckedAll] = useState(false);
    const [selectedAll, setSelectedAll] = useState({...SelectedModel});

    const [params, setParams] = useState({
        groups: [],
        islands: [],
        routes: [],
        zones: [],
    });

    const headersTable = [
        {name: "UID", attr: 0, direction: "asc", active: true, default: true},
        {name: "UUID", attr: 1, direction: "asc", active: false},
        {name: _Tt("containers.address"), attr: 2, direction: "asc", active: false},
    ];

    useEffect(() => {
        setIsLoading(true);
        document.title = title;
        pagerRef.current.active = true;
        pagerRef.current.handleCallApi = () => {
            applyFilters();
        };
        orderingRef.current.setHeaders(headersTable);
        orderingRef.current.applyOrder = () => applyFilters();
        axiApi
            .get("/api/reports/containers/filters/")
            .then((resp) => {
                let params_ = {...params};
                params_.groups = [...resp.data.groups];
                params_.islands = [...resp.data.islands];
                params_.routes = [...resp.data.routes];
                params_.zones = [...resp.data.zones];
                setParams(params_);
            })
            .finally(() => setIsLoading(false));
    }, []);

    const applyFilters = () => {
        setIsLoading(true);
        axiApi
            .post("/api/reports/performance/", filters.current.chosen, {
                params: {...pagerRef.current.paging.getParams(), ...orderingRef.current.getParams()},
            })
            .then((resp) => {
                selected.current = [];
                const selectedAll_ = {...SelectedModel};
                setCheckedAll(false);
                if ("items" in resp.data && resp.data.items.length) {
                    itemsRef.current = [...resp.data.items];
                    setItemsShown([...resp.data.items]);
                    setDays(resp.data.days);
                    pagerRef.current.paging.update(resp.data.pager);
                    selectedAll_.textQuestion = "Seleccionar los " + pagerRef.current.paging.count + " registros";
                    selectedAll_.textAll = pagerRef.current.paging.count + " seleccionados";
                } else {
                    setItemsShown([]);
                    setDays("");
                }
                setSelectedAll(selectedAll_);
            })
            .finally((err) => {
                setIsLoading(false);
            });
    };

    const downloadFilters = () => {
        if (selected.current.length === 0) {
            Alert.warning("No se han seleccionado registros para descargar");
            return false;
        }
        let uuids = [];
        selected.current.forEach((idx) => {
            uuids.push(itemsRef.current[idx].uuid);
        });
        let DataSend = {};
        if (selectedAll.all) {
            DataSend = {...filters.current.chosen, all: true};
        } else {
            DataSend = {
                uuids: uuids,
                start: filters.current.chosen.start,
                end: filters.current.chosen.end,
            };
        }

        // , {responseType: 'blob'}
        axiApi
            .post("/api/reports/performance/download/", DataSend, {
                responseType: "blob",
            })
            .then((resp) => {
                const contentDisposition = resp.headers["content-disposition"];
                const contentType = resp.headers["content-type"];
                let filename = "downloaded-file";
                if (contentDisposition) {
                    const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                    if (filenameMatch.length === 2) {
                        filename = filenameMatch[1];
                    }
                }
                const blob = new Blob([resp.data], {type: contentType});
                const urlBlob = window.URL.createObjectURL(blob);
                const linkTemp = document.createElement("a");
                linkTemp.href = urlBlob;
                linkTemp.setAttribute("download", filename);
                document.body.appendChild(linkTemp);
                linkTemp.click();
                document.body.removeChild(linkTemp);
            })
            .catch((err) => {
                Alert.error("Error en el servidor", "");
            });
    };

    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <div className="row">
                <div className="col-12">
                    <h3 className="mt-2">{title}</h3>
                    <ContainersListFilters
                        filters={filters}
                        params={params}
                        applyFilters={applyFilters}
                        downloadFilters={downloadFilters}
                        setItemsShown={setItemsShown}
                    />
                </div>
            </div>
            <TopBarPagination pagerModel={pagerRef.current} stickyTopValue="72px" />
            <div className="row">
                <div className="col-12">
                    <LoaderSpinner isLoading={isLoading}>
                        <ContainersListTable
                            itemsShown={itemsShown}
                            selected={selected}
                            isLoading={isLoading}
                            checkedAll={checkedAll}
                            setCheckedAll={setCheckedAll}
                            days={days}
                            selectedAll={selectedAll}
                            setSelectedAll={setSelectedAll}
                            pagerRef={pagerRef}
                            orderingRef={orderingRef}
                        />
                    </LoaderSpinner>
                </div>
            </div>
        </>
    );
};
export default ReportPerformance;
